<main>
  <ng-container *transloco="let t">
    <section class="wallpaper"></section>

    <section class="login">
      <div style="width: 100%">
        <button
          type="button"
          (click)="back()"
          class="back-arrow-icon icon icon-m back-btn"
          [attr.aria-label]="t('Back')"
        ></button>
      </div>

      <div
        style="
          display: flex;
          flex-direction: column;
          max-width: 360px;
          justify-content: center;
          align-items: center;
        "
      >
        <div class="logo-wrapper">
          <p class="logo"></p>
        </div>
        <div class="welcome-text">
          <h2>{{ t('Activate Your Account') }}</h2>
          <p>
            @if (isManagerActivation()) {
              {{
                t(
                  'Enter the email address where you received the manager welcome message. We will send you a link to set your password.'
                )
              }}
            } @else {
              {{
                t(
                  'Enter your email and we will send you a link to activate your account or restore a deleted clinic.'
                )
              }}
            }
          </p>
        </div>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <div class="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col">
            <div style="width: 100%">
              <label
                for="email"
                class="block text-sm font-medium leading-6 text-gray-900"
                >{{ t('Email') }}</label
              >
              <div class="relative mt-2 rounded-md shadow-sm">
                <div
                  class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                >
                  <span class="icon email-icon"></span>
                </div>
                <input
                  formControlName="email"
                  matInput
                  id="email"
                  type="email"
                  class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>

              <div style="height: 24px; margin-bottom: 4px">
                @if (form.controls['email'].hasError('pattern')) {
                  <mat-error>
                    {{ t('Enter valid email') }}
                  </mat-error>
                }
              </div>
            </div>

            <div>
              <button
                mat-flat-button
                class="primary-btn"
                type="submit"
                [disabled]="form.invalid || store.status() === status.Loading"
              >
                @if (store.status() !== status.Loading) {
                  {{ t('Submit') }}
                } @else {
                  <span
                    class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                  ></span>
                  {{ t('Submitting...') }}
                }
              </button>
            </div>
          </div>
        </form>
      </div>

      <div></div>
    </section>
  </ng-container>
</main>
